const menuButton = document.querySelector('#menu-button')
const menu = document.querySelector('#site-navigation')
const menuOverlay = document.querySelector('#menu-overlay')

const subMenus = document.querySelectorAll('#site-navigation .sub-menu')
const backNav = document.querySelectorAll('.back-nav')
const subMenuLink = document.querySelectorAll('#site-navigation .menu-item-has-children > a')
const noMenuLinkTitle = document.querySelectorAll('.nav-section-title-no-link > a')
const noMenuLink = document.querySelectorAll('.no-top-level-page > a')

function updateBodyMenuClasses() {
  const isMenuOpen = menu.classList.contains('is-open')
  document.body.classList.toggle('menu-mobile-open', isMenuOpen)
}

menuButton.addEventListener('click', (e) => {
  e.preventDefault()
  const isOpen = menu.classList.toggle('is-open')
  menuButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
  updateBodyMenuClasses()
  if (!isOpen) {
    closeSubMenus()
  }
})

updateBodyMenuClasses()

if (menuOverlay) {
  menuOverlay.addEventListener('click', () => {
    menu.classList.remove('is-open')
    menuButton.setAttribute('aria-expanded', 'false')
    updateBodyMenuClasses()
    closeSubMenus()
  })
}

noMenuLink.forEach((btn) => {
  btn.addEventListener('click', (event) => {
    event.preventDefault()
  })
})

noMenuLinkTitle.forEach((btn) => {
  btn.addEventListener('click', (event) => {
    event.preventDefault()
  })
})

subMenuLink.forEach((btn) => {
  btn.addEventListener('click', (event) => {
    if (btn.classList.contains('sub-nav-btn')) {
      event.preventDefault()
    }
    const menuItem = btn.closest('.menu-item-has-children')
    const whichSub = menuItem?.querySelector(':scope > ul.sub-menu')
    if (!whichSub) {
      return
    }
    whichSub.classList.add('opensub-menu')
    document.body.classList.add('drop-menu-open')
  })
})

backNav.forEach((btn) => {
  btn.addEventListener('click', (event) => {
    event.preventDefault()
    const parentSub = btn.closest('.sub-menu')
    if (parentSub) {
      parentSub.classList.remove('opensub-menu')
    }
  })
})

function closeSubMenus() {
  subMenus.forEach((btn) => {
    btn.classList.remove('opensub-menu')
  })
}
